import { useField } from 'formik';
import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useRouteMatch } from 'react-router-dom';
import { TextInput } from '../../../components/Form';
import { useDocumentQuery, useDocumentTypeQuery } from '../../../generated/graphql';
import routes from '../../../routes/routes';

interface AdditionalFieldsProps {
    editedAttachmentIds?: number[] | null;
    setEditedAttachmentIds(ids: any): void;
}

export const UploadedAttachments: React.FC<AdditionalFieldsProps> = ({
    editedAttachmentIds,
    setEditedAttachmentIds,
}) => {
    const match: any = useRouteMatch(`${routes.editDocument}/:id`);
    const id = match?.params?.id;
    const { data, loading, refetch } = useDocumentQuery({ variables: { id: +id } });

    const deleteAttachment = useCallback(
        (id: number) => {
            setEditedAttachmentIds((ids: number[]) => ids.filter((arrayId) => arrayId !== id));
        },
        [setEditedAttachmentIds],
    );

    return (
        <div>
            {data?.document?.attachments?.map((attachment) => {
                if (editedAttachmentIds?.includes(attachment.id)) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <span style={{ flex: 1 }}> {attachment.name}</span>{' '}
                            <Button style={{ margin: 5 }} as="a" href={attachment?.url || ''} target="_blank">
                                Переглянути
                            </Button>
                            <Button
                                style={{ margin: 5 }}
                                variant="danger"
                                onClick={() => deleteAttachment(attachment.id)}
                            >
                                Видалити
                            </Button>
                        </div>
                    );
                }
            })}
        </div>
    );
};
